export const GET_ALL_SPREED_SHEET = "GET_ALL_SPREED_SHEET"
export const CREATE_SPREED_SHEET = "CREATE_SPREED_SHEET"
export const UPDATE_SPREED_SHEET = "UPDATE_SPREED_SHEET"
export const DELETE_SPREED_SHEET = "DELETE_SPREED_SHEET"
export const SELECT_SPREED_SHEET = "SELECT_SPREED_SHEET"
